import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AvailabilityItem\UpdateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/UpdateAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
const UpdateAvailabilityItemController = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAvailabilityItemController.url(args, options),
    method: 'put',
})

UpdateAvailabilityItemController.definition = {
    methods: ["put"],
    url: '/api/unavailability/items/{availability_item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\AvailabilityItem\UpdateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/UpdateAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
UpdateAvailabilityItemController.url = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { availability_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { availability_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            availability_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        availability_item: typeof args.availability_item === 'object'
        ? args.availability_item.id
        : args.availability_item,
    }

    return UpdateAvailabilityItemController.definition.url
            .replace('{availability_item}', parsedArgs.availability_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailabilityItem\UpdateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/UpdateAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
UpdateAvailabilityItemController.put = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAvailabilityItemController.url(args, options),
    method: 'put',
})

export default UpdateAvailabilityItemController